import { PropsWithChildren } from 'react';
import { LoanApplicationContext, LoanApplicationContextType } from './Context';
import o2ApiService from '@n2-common/services/o2Service';
import { getTracking } from '@n2-common/lib/useTracking';
import { Outcome, OutcomeValues, PostLoanApplicationResult, redirect } from '@n2-common/models';
import pollForApplicationState from '@n2-common/services/o2Service/pollForApplicationState';
import { State } from '@n2-common/services/o2Service/types';

const context: LoanApplicationContextType = {
    async postLoanApplication(values): Promise<PostLoanApplicationResult> {
        const application = { ...values, Tracking: await getTracking() };
        const applicationId = await o2ApiService.postApplication(application, 'NO', 'loan');

        const state = await pollForApplicationState(applicationId, null, (s) => s != null);
        if (!state) {
            return { outcome: 'Pending', applicationId };
        }
        if (state.status == 'Redirect') {
            return { outcome: 'Redirect', applicationId, applicantId: state.applicantId };
        }
        return { outcome: getOutcome(state.status), applicationId };
    },
    redirect,
};

export const LoanApplicationContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
    return <LoanApplicationContext.Provider value={context}>{children}</LoanApplicationContext.Provider>;
};

function getOutcome(status: State): Outcome {
    if ((OutcomeValues as ReadonlyArray<string>).includes(status)) {
        return status as Outcome;
    }
    return 'Pending';
}
